<div class="relative" style="padding-top: 6% !important;">

    <div class="text-center g-c-primaryDarkColor  font-bold text-2xl mx-auto" style="margin-top: 2rem !important;">
        {{ 'OrganizationHierarchy' | navTitle | async }}
    </div>

    <div
        class=" flex flex-wrap gap-2  justify-content-center mt-4 fixed-list g-bg-white px-3 py-1 shadow-5 border-round-lg">
        <p-button (onClick)="expandAll()">
            <div class="flex gap-3 align-items-center">
                <span>
                    {{"open_all"|translate}}
                </span>
            </div>
        </p-button>

        <p-button (onClick)="collapseAll()">
            <div class="flex gap-3 align-items-center">
                <span>
                    {{"close_all"|translate}}
                </span>
            </div>
        </p-button>

        <p-button (onClick)="compact(true)">
            <div class="flex gap-3 align-items-center">
                <span>
                    {{"compact"|translate}}
                </span>
            </div>
        </p-button>

        <p-button (onClick)="compact(false)">
            <div class="flex gap-3 align-items-center">
                <span>
                    {{"horizontal_compact"|translate}}
                </span>
            </div>
        </p-button>

        <p-button (onClick)="zoomIn()">
            <div class="flex gap-3 align-items-center">
                <span>
                    {{"zoom_in"|translate}}
                </span>
            </div>
        </p-button>

        <p-button (onClick)="zoomOut()">
            <div class="flex gap-3 align-items-center">
                <span>
                    {{"zoom_out"|translate}}
                </span>
            </div>
        </p-button>
        <p-button (onClick)="fitScreen()">
            <div class="flex gap-3 align-items-center">
                <span>
                    {{"fit"|translate}}
                </span>
            </div>
        </p-button>
        <!-- 
        <p-button (onClick)="printSvgChart()">
            <div class="flex gap-3 align-items-center">
                <span>
                    {{"print"|translate}}
                </span>
                <i class="pi pi-print"></i>
            </div>
        </p-button> -->
        <button pButton label="طباعة الشجرة" icon="pi pi-print" (click)="printOrgChart()" class="mb-3"></button>


        <p-button (onClick)="goBack()">
            <div class="flex gap-2 ">
                {{"back"|translate}}
                @if(dir=='rtl'){
                <i class="pi pi-arrow-circle-left"></i>
                }@else {
                <i class="pi pi-arrow-circle-right"></i>
                }
            </div>
        </p-button>
    </div>
    <div #chartContainer id="chartContainer" class="chartContainer pt-3">
        <ul class="flex flex-row gap-3 justify-content-center">
            <li class="flex gap-2 align-items-center">
                <span class="h-1rem w-1rem " style="background-color: var(--primary-darker-color)">
                </span>
                <i class="fa-solid fa-sitemap"></i>
                <span>
                    {{'a-department'|translate}}
                </span>
            </li>
            <li class="flex gap-2 align-items-center">
                <span class="h-1rem w-1rem " style="background-color: #6b7280;">
                </span>
                <i class="fa-solid fa-folder-tree"></i>
                <span>
                    {{'a-section'|translate}}
                </span>

            </li>
            <li class="flex gap-2 align-items-center">
                <span class="h-1rem w-1rem" style="background-color: #6b7280;">
                </span>
                <i class="fa-solid fa-building-user"></i>
                <span>
                    {{'an-office'|translate}}
                </span>

            </li>
        </ul>
    </div>
</div>